// src/resources/entityReports/constants.js

export const ENTITY_REPORT_STATUS_CONFIG = [
    { status: 'NEW', label: 'Nouveaux', color: 'error' },
    { status: 'REVIEWING', label: 'En revue', color: 'warning' },
    { status: 'RESOLVED', label: 'Résolus', color: 'success' },
    { status: 'DISMISSED', label: 'Classés', color: 'default' },
];

export const ENTITY_REPORT_STATUS_CHOICES = ENTITY_REPORT_STATUS_CONFIG.map(({ status, label }) => ({
    id: status,
    name: label,
}));

export const ENTITY_TYPE_CHOICES = [
    { id: 'RDF', name: 'RDF' },
    { id: 'SUBJECT', name: 'Subjects' },
    { id: 'OOBJECT', name: 'Oobjects' },
];
